import { Component } from 'react'
import { getYoutubeIdFromUrl } from '@constants'
import { IconYoutube, EmptyState, Section, Image } from '@tracklib/kit'

import styles from './videoblock.css'

type VideoProps = {
  value: {
    video_url: string
    thumbnail_size: number
    thumbnail_override?: number
    fit_in_container: boolean
    title: string
  }
}

type VideoState = {
  active: boolean
  isMobile: boolean
}

class Video extends Component<VideoProps, VideoState> {
  state = {
    active: false,
    isMobile: false,
  }

  componentDidMount() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
      this.setState({ active: true, isMobile: true })
    }
  }

  handleClickPlay = () => {
    this.setState({ active: true })
  }

  render() {
    const { active, isMobile } = this.state
    const {
      value: { video_url, thumbnail_size, title, fit_in_container, thumbnail_override },
    } = this.props
    const id = getYoutubeIdFromUrl(video_url)

    if (!id) {
      return <EmptyState text="Can't load video" emoji="sad" />
    }

    return (
      <Section size={fit_in_container ? 'small' : 'medium'}>
        <button
          className={styles.wrapper}
          style={
            !thumbnail_override
              ? {
                  backgroundImage: `url(https://i.ytimg.com/vi/${id}/${+thumbnail_size === 1 ? 'hqdefault' : 'maxresdefault'}.jpg)`,
                }
              : {}
          }
          onClick={this.handleClickPlay}
        >
          {thumbnail_override && !active && <Image image={thumbnail_override} alt="" absolute sizes="(min-width: 769px) 80vw, 100vw" />}
          <IconYoutube className={styles.icon} />
          {title && <p className={styles.title}>{title}</p>}
          {active && (
            <iframe
              title={`youtube-${id}`}
              className={styles.video}
              src={`https://www.youtube.com/embed/${id}?autoplay=${isMobile ? 0 : 1}&iv_load_policy=3&playsinline=1`}
              frameBorder="0"
            />
          )}
        </button>
      </Section>
    )
  }
}

export default Video
